import type { ReactNode } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Container } from "@/components/site/Container";
import { Overline } from "@/components/site/Overline";
import type { FaqItem } from "@/content/faqs";
import { RichText } from "@/components/site/RichText";

type Props = {
  items: FaqItem[];
  title?: string;
  intro?: ReactNode;
  className?: string;
};

export function FaqSection({
  items,
  title = "Veelgestelde vragen",
  intro,
  className = "bg-surface",
}: Props) {
  return (
    <section className={`py-16 lg:py-30 ${className}`}>
      <Container>
        <div className="max-w-3xl">
          <Overline>Veelgestelde vragen</Overline>
          <h2 className="mt-4 font-display text-[clamp(1.5rem,3vw,1.75rem)] font-semibold leading-[1.2] text-foreground">
            {title}
          </h2>
          {intro ? <p className="mt-4 text-[17px] leading-7 text-on-surface-variant">{intro}</p> : null}
          <Accordion type="single" collapsible className="mt-8 border-t border-border">
            {items.map((item, i) => (
              <AccordionItem key={item.q} value={`faq-${i}`} className="border-border">
                <AccordionTrigger className="text-left text-base font-semibold text-foreground">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="max-w-[70ch] text-base leading-relaxed text-on-surface-variant">
                  <RichText waarde={item.a} />
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Container>
    </section>
  );
}
